var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.57504 19.4251C4.29384 19.1438 4.13586 18.7623 4.13586 18.3646C4.13586 17.9668 4.29384 17.5854 4.57504 17.3041L9.87904 12.0001L4.57504 6.69608C4.30181 6.41317 4.15062 6.03427 4.15403 5.64098C4.15745 5.24768 4.3152 4.87146 4.59332 4.59335C4.87143 4.31524 5.24765 4.15749 5.64094 4.15407C6.03424 4.15065 6.41314 4.30184 6.69604 4.57508L12 9.87908L17.304 4.57508C17.5869 4.30184 17.9658 4.15065 18.3591 4.15407C18.7524 4.15749 19.1287 4.31524 19.4068 4.59335C19.6849 4.87146 19.8426 5.24768 19.8461 5.64098C19.8495 6.03427 19.6983 6.41317 19.425 6.69608L14.121 12.0001L19.425 17.3041C19.6983 17.587 19.8495 17.9659 19.8461 18.3592C19.8426 18.7525 19.6849 19.1287 19.4068 19.4068C19.1287 19.6849 18.7524 19.8427 18.3591 19.8461C17.9658 19.8495 17.5869 19.6983 17.304 19.4251L12 14.1211L6.69604 19.4251C6.41475 19.7063 6.03329 19.8643 5.63554 19.8643C5.2378 19.8643 4.85634 19.7063 4.57504 19.4251Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseWhite);
export default __webpack_public_path__ + "static/media/icon-close-white.b69dcc3fa8e31541ef279b4e42166b0b.svg";
export { ForwardRef as ReactComponent };